import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VSimpleTable, VAlert, VBtn, VIcon } from "vuetify/lib";
import DemoSection from '../../components/DemoSection.vue';
import CodePreview from '../../components/CodePreview.vue';
import data from '@/assets/docs/beos-icon.json';
import { ICONS } from "@begentoOS/begento-ui";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosIconDemo',
    setup(__props) {
        const propsDocs = ref(data.props);
        const slotsDocs = ref(data.slots);
        const basicUsage = '<BeosIcon color="primary">mdi-home</BeosIcon>';
        const sizesUsage = '<BeosIcon size="small">mdi-star</BeosIcon>\n<BeosIcon size="40">mdi-star</BeosIcon>';
        const themeUsage = '<div class="black">\n  <BeosIcon theme="dark">mdi-white-balance-sunny</BeosIcon>\n</div>';
        return { __sfc: true, propsDocs, slotsDocs, basicUsage, sizesUsage, themeUsage, VContainer, VRow, VCol, VSimpleTable, VAlert, VBtn, VIcon, DemoSection, CodePreview, ICONS };
    }
});
